<template>
  <div>
    <h2>Verify your Identity</h2>
    <p>In order to keep Runstack a safe solution, we require new users to verify their identity with a payment method.<br>
      <strong>We won't charge your card.</strong></p>

    <BillingStripeCard
      ref="card"
      save-label="Save payment method"
      :show-cancel="false"
      :show-email="false"
      :show-business="false"
      force-create
      @save="save"
    />
  </div>
</template>

<script>
import BillingStripeCard from '../Billing/StripeCard'

export default {
  components: {
    BillingStripeCard
  },
  methods: {
    save () {
      this.$store.dispatch('auth')
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    line-height: 20px;
  }

  h5 {
    margin: 0 0 15px;
  }

  .el-button {
    width: 100%;
  }

  #stripe-card {
    margin-top: 30px;
  }

  #stripe-billing {
    margin-bottom: 30px;
  }
</style>
